import { makeAutoObservable } from "mobx";
import type { TickerProps } from "./trade";
import type { TradeRecentProps } from "./trade";
import type { DepthAryProps } from "./trade";

/** CFD 页高频展示数据，与 store.trade 分离，避免整页因 ticker/盘口/成交 更新而重渲染 */
interface CfdViewState {
  cfdTicker: WithUndefined<TickerProps>;
  /** 最近一次收到 ticker 推送的本地时间戳（用于股票/大宗等非 24h 交易对开仓前校验） */
  cfdTickerUpdateTime: WithUndefined<number>;
  /** Kline 接口返回的当前交易对最新一根 K 线的时间（毫秒），socket 从未推送时用此时间做 30 分钟判断 */
  lastKlineBarTime: WithUndefined<number>;
  depthAsks: WithUndefined<DepthAryProps>;
  depthBids: WithUndefined<DepthAryProps>;
  tradeRecent: WithUndefined<TradeRecentProps | null>;
  /** 仓位列表中「非当前交易对」的 ticker，key 为 symbol 小写（如 btc_usdt_cfd），用于实时更新其他币对仓位的最新价与收益 */
  positionTickers: Record<string, TickerProps>;
}

const cfdView = makeAutoObservable(
  {
    cfdTicker: undefined as CfdViewState["cfdTicker"],
    cfdTickerUpdateTime: undefined as CfdViewState["cfdTickerUpdateTime"],
    lastKlineBarTime: undefined as CfdViewState["lastKlineBarTime"],
    depthAsks: undefined as CfdViewState["depthAsks"],
    depthBids: undefined as CfdViewState["depthBids"],
    tradeRecent: undefined as CfdViewState["tradeRecent"],
    positionTickers: {} as CfdViewState["positionTickers"],

    updateState(payload: Partial<CfdViewState>) {
      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          (this as any)[key] = payload[key];
        }
      }
    },
  },
  {},
  { autoBind: true, deep: false }
);

export default cfdView;
